import React from "react";

const Container = ({ children }) => <div className="Container">{children}</div>;

export default Container;
